module.exports = __webpack_public_path__ + "media/images/wines/blanco-airen/bottle-d1ab5a9f73ad328553bc5fe072c01903.png";